var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40184 16.4337C8.34878 16.4337 8.2963 16.4227 8.2477 16.4014C8.1991 16.3801 8.15542 16.349 8.11941 16.3101L0.504527 8.07297C0.453765 8.01806 0.420112 7.94953 0.407689 7.87579C0.395265 7.80205 0.404609 7.72628 0.434578 7.65776C0.464546 7.58925 0.513839 7.53096 0.576423 7.49002C0.639007 7.44908 0.712167 7.42728 0.78695 7.42728H4.45234C4.50737 7.42729 4.56176 7.4391 4.61184 7.46192C4.66192 7.48473 4.70652 7.51803 4.74264 7.55955L7.28757 10.4874C7.5626 9.89947 8.09503 8.92055 9.02934 7.7277C10.4106 5.96424 12.9797 3.37074 17.3753 1.02951C17.4602 0.984268 17.5591 0.972526 17.6522 0.996602C17.7454 1.02068 17.8262 1.07882 17.8786 1.15955C17.931 1.24028 17.9513 1.33773 17.9353 1.43266C17.9194 1.52758 17.8685 1.61309 17.7926 1.67228C17.7758 1.68539 16.081 3.02001 14.1306 5.46459C12.3355 7.7142 9.94926 11.3927 8.77507 16.1415C8.75444 16.2249 8.70646 16.2991 8.6388 16.352C8.57113 16.405 8.48766 16.4338 8.40172 16.4338L8.40184 16.4337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b2644d694df56c629c5066d0625e408f.svg";
export { ForwardRef as ReactComponent };